const getCategories = (field: Gatsby.Maybe<Pick<Gatsby.PrismicStructuredTextType, "raw">>): string[] => {
  return field?.raw?.map((c: any) => c?.text?.trim()).filter((c: any) => !!c && typeof c === "string") ?? [];
}

export default getCategories;
